<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Call Request</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> /

      <b>Call Requests</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Pending
              <span
                class="badge badge-pill badge-danger"
                v-if="pendings.length !== 0"
                >{{ pendings.length }}</span
              >
            </h4>

            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="table-responsive">
              <table
                id="tba_pending_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Date</th>
                    <th>Customer Name</th>
                    <th>Mobile No.</th>
                    <th>Product</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(pending, i) in pendings"
                    :key="i"
                    :class="{ 'text-danger': isEmergency(pending) }"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      {{ pending.created_at | moment("Do MMMM YYYY, h:mm a") }}
                    </td>
                    <td>
                      <router-link :to="customerPage(pending.customer_ic)">
                        {{ pending.user != null ? pending.user.name : "" }}
                      </router-link>
                    </td>
                    <td>
                      {{
                        pending.user != null ? pending.user.mobile_number : ""
                      }}
                    </td>
                    <td>
                      <router-link :to="productPage(pending.product_id)">
                        {{
                          pending.product != null ? pending.product.name : ""
                        }}
                      </router-link>
                    </td>
                    <td>
                      <button
                        @click="updateButton(pending.id)"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        Called
                      </button>
                      <button
                        @click="goToDetail(pending.id)"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color:#AC8400; border-color: #AC8400;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- TBK -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Called</h4>

            <!-- <p>The table below shows call requests for TBK.</p> -->

            <div class="table-responsive">
              <table
                id="tba_called_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Agent Name</th>
                    <th>Date</th>
                    <th>Called At</th>
                    <th>Time Difference</th>
                    <th>Customer Name</th>
                    <th>Mobile No.</th>
                    <th>Product</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(called, x) in called" :key="x">
                    <td>{{ x + 1 }}</td>
                    <td>{{ called.staff.user.name }}</td>
                    <td>
                      {{ called.created_at | moment("Do MMMM YYYY, h:mm a") }}
                    </td>
                    <td>
                      {{ called.updated_at | moment("Do MMMM YYYY, h:mm a") }}
                    </td>
                    <td>{{ getTimeDifference(called) }}</td>
                    <td>
                      <router-link :to="customerPage(called.customer_ic)">
                        {{ called.user != null ? called.user.name : "" }}
                      </router-link>
                    </td>
                    <td>
                      {{ called.user != null ? called.user.mobile_number : "" }}
                    </td>
                    <td>
                      <router-link :to="productPage(called.product_id)">
                        {{ called.product != null ? called.product.name : "" }}
                      </router-link>
                    </td>
                    <td>
                      <button
                        @click="detailButton(called)"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color:#AC8400; border-color: #AC8400;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import router from "../../router";

export default {
  name: "tba_call_request",

  data() {
    return {
      pendings: [
        {
          created_at: "",
          customer: {
            id: "",
            mobile_number: "",
            user: { name: "" }
          },
          product: { name: "", id: "" }
        }
      ],
      called: [
        {
          created_at: "",
          updated_at: "",
          customer: {
            id: "",
            mobile_number: "",
            user: {
              name: ""
            }
          },
          staff: {
            user: { name: "" }
          },
          product: {
            name: "",
            id: ""
          }
        }
      ]
    };
  },

  methods: {
    loadPendingsCalls() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .get("/calls/pendings/tba", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.destroyPendingDatatable();

            this.pendings = res.data;
            // this.called = res.data.called;
          })
          .then(function() {
            $("#tba_pending_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                }
              ]
            });
          });
      }
    },

    loadCalledCalls() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .get("/calls/called/tba", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.destroyCalledDatatable();
            this.called = res.data;
          })
          .then(function() {
            $("#tba_called_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    destroyPendingDatatable() {
      $("#tba_pending_tbl")
        .DataTable()
        .destroy();
    },

    destroyCalledDatatable() {
      $("#tba_called_tbl")
        .DataTable()
        .destroy();
    },

    loadAllCalls() {
      this.loadPendingsCalls();
      this.loadCalledCalls();
    },

    updateButton(call_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/calls/" + call_id,
            {
              _method: "PATCH"
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (!res.data.success) {
              swal("Error!", res.data.message, "error");
            } else {
              this.loadAllCalls();
            }
          });
      }
    },

    detailButton(call) {
      router.push({
        path: `tba_call_request/detail/${call.id}`,
        params: {
          id: call.call_id,
          callName: call.name,
          callProduct: call.product
        }
      });
    },

    isEmergency(pending) {
      let created = new Date(pending.created_at);
      let current = new Date();

      let diff = Math.abs(current - created);

      // Milliseconds, Seconds
      // min is in minutes
      let min = Math.ceil(diff / (1000 * 60));

      if (min >= 60) {
        return true;
      }
    },

    goToDetail(id) {
      this.$router.push(`/tba_call_request/detail/${id}`);
    },

    getTimeDifference(call) {
      let created_time = new Date(call.created_at);
      let called_time = new Date(call.updated_at);

      let mins = moment
        .utc(
          moment(called_time, "DD/MM/YYYY HH:mm:ss").diff(
            moment(created_time, "DD/MM/YYYY HH:mm:ss")
          )
        )
        .format("HH:mm:ss");

      let day = moment(called_time).diff(moment(created_time), "days");

      let time = day + " day(s) " + mins;

      return time;
    },

    customerPage(id) {
      return "/customer/" + id;
    },

    productPage(id) {
      return "/marketing/product/detail/" + id;
    }
  },

  mounted() {
    this.loadAllCalls();
  }
};
</script>
